import { render, staticRenderFns } from "./olderMember.vue?vue&type=template&id=ec594ea2&scoped=true"
import script from "./olderMember.vue?vue&type=script&lang=js"
export * from "./olderMember.vue?vue&type=script&lang=js"
import style0 from "./olderMember.vue?vue&type=style&index=0&id=ec594ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec594ea2",
  null
  
)

export default component.exports